import React from 'react';
import { Link } from 'react-router-dom';
import { PackageCardProps } from '../types';
import { getMinimumListingPrice } from '../utils/pricing';
import '../styling/PackageCard.css';

const PackageCard: React.FC<PackageCardProps> = ({ pkg }) => {
  const { price: minimumGroupPrice, groupSize: minGroupSize } = getMinimumListingPrice(pkg.pricing);

  return (
    <div className="package-card">
      <div className="image-container">
        <img className="package-image" src={pkg.images[0]} alt={pkg.title} />
        <div className="location-tag">{pkg.location}</div>
      </div>
      <div className="package-content">
        <h3 className="package-title">{pkg.title}</h3>
        <p className="package-description">{pkg.description}</p>
        <div className="package-footer">
          <div className="package-price">
            <span className="main-price">₹{minimumGroupPrice.toLocaleString()}</span>
            <span className="package-sub-price">/ person ({minGroupSize}+ people)</span>
            <span className="package-duration">{pkg.overview?.duration || 'Indefinite Days'}</span>
          </div>
          <Link className="view-button" to={`/packages/${pkg.id}`}>
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
